const districtTypes = {
    1: "jerusalem",
    2: "tzafon",
    3: "haifa",
    4: "merkaz",
    5: "telaviv",
    6: "darom"
}

export default districtTypes;